import { render, staticRenderFns } from "./Bankruptcies.vue?vue&type=template&id=1500b694&"
import script from "./Bankruptcies.vue?vue&type=script&lang=js&"
export * from "./Bankruptcies.vue?vue&type=script&lang=js&"
import style0 from "./Bankruptcies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports